module.exports = __webpack_public_path__ + "img/清河头乡-c.f6364976.png";